import _ from "lodash"

export const GEO_URL =
"https://raw.githubusercontent.com/zcreativelabs/react-simple-maps/master/topojson-maps/world-110m.json"

// read-only key, only exposes public data
const KEY = "keyFRBqnIvAd1gkXG"
export const getApiLink = (tableName) => {
  return `https://api.airtable.com/v0/appfS3glFVXDszRVn/${tableName}?api_key=${KEY}`
}

export const MODE_DATA = {
  consultants: {
    headerText: "EIC Consultants",
    colors: {
      primary: "#edeac9",
      // primary: "#d7d3a0",
      // primary: "#b89fd3ee", EIC purple
      // primary: "#1b63c188",
      secondary: "#f5f4dc",
      // secondary: "#f4f2d1",
      // secondary: "#b89fd3aa", EIC purple
      // secondary: "#5a87c144",
      outline: "#6d2e00bd",
      // primary: "#1b63c1e3",
      // secondary: "#5a87c126",
    },
  },
  projects: {
    headerText: "EIC Projects",
    colors: {
      primary: "#149E6Ae3",
      secondary: "#58998026",
      outline: "#00000055",
    },
  },
}

export const PIN_FILL_OPACITY = 1
export const PIN_GRAD_OPACITY = 0.3
export const PIN_STROKE_OPACITY = 1
export const PIN_STROKE = "#555"
export const PIN_SHAFT_WIDTH = 1.2
export const PIN_HEAD_STROKE_WIDTH = 0
// export const PIN_SHAFT_STROKE_WIDTH = 0.2;

export const PIN_WIDTH = 7
export const PIN_HEIGHT = 10
export const PIN_HEAD_SCALE = 1

const degToRad = (d) => (d * Math.PI) / 180
const radToDeg = (r) => (r * 180) / Math.PI
const getRandom = (spread) => spread * (Math.random() - 0.5)

// default tilt
export const ROTATION_DEFAULT = degToRad(13)
// radians assigned per unit of col_rotation assigned in sheet
export const ROTATION_MAGNITUDE = (2 * Math.PI) / 7
// range of added randomness
export const RANDOMN_ROTATIONAL_SPREAD = degToRad(10)
export const RANDOM_SHIFT_FACTOR = 0.05

export const getTransform = (rotationMultiple) => {
  let pinRotation = ROTATION_DEFAULT
  // slight random rotational variance for realism
  pinRotation += getRandom(RANDOMN_ROTATIONAL_SPREAD)
  pinRotation += rotationMultiple * ROTATION_MAGNITUDE

  const transX =
    // slight random offset for realism
    // ((PIN_WIDTH + PIN_HEIGHT) * RANDOM_SHIFT_FACTOR * rotationMultiple) +
    getRandom((PIN_WIDTH + PIN_HEIGHT) * RANDOM_SHIFT_FACTOR) +
    Math.sin(pinRotation) * PIN_HEIGHT -
    (Math.cos(pinRotation) * PIN_WIDTH) / 2
  const transY =
    // slight random offset for realism
    getRandom((PIN_WIDTH + PIN_HEIGHT) * RANDOM_SHIFT_FACTOR) -
    Math.cos(pinRotation) * PIN_HEIGHT -
    (Math.sin(pinRotation) * PIN_WIDTH) / 2

  const degRotation = radToDeg(pinRotation)
  const trans = `translate(${transX}, ${transY}) rotate(${degRotation})`
  return trans
}

// export const COUNTRIES = [
//   "Afghanistan",
//   "Angola",
//   "Albania",
//   "United Arab Emirates",
//   "Argentina",
//   "Armenia",
//   "Antarctica",
//   "Fr. S. Antarctic Lands",
//   "Australia",
//   "Austria",
//   "Azerbaijan",
//   "Burundi",
//   "Belgium",
//   "Benin",
//   "Burkina Faso",
//   "Bangladesh",
//   "Bulgaria",
//   "Bahamas",
//   "Bosnia and Herz.",
//   "Belarus",
//   "Belize",
//   "Bolivia",
//   "Brazil",
//   "Brunei",
//   "Bhutan",
//   "Botswana",
//   "Central African Rep.",
//   "Canada",
//   "Switzerland",
//   "Chile",
//   "China",
//   "C",
//   "Cameroon",
//   "Dem. Rep. Congo",
//   "Congo",
//   "Colombia",
//   "Costa Rica",
//   "Cuba",
//   "N. Cyprus",
//   "Cyprus",
//   "Czechia",
//   "Germany",
//   "Djibouti",
//   "Denmark",
//   "Dominican Rep.",
//   "Algeria",
//   "Ecuador",
//   "Egypt",
//   "Eritrea",
//   "Spain",
//   "Estonia",
//   "Ethiopia",
//   "Finland",
//   "Fiji",
//   "Falkland Is.",
//   "France",
//   "Gabon",
//   "United Kingdom",
//   "Georgia",
//   "Ghana",
//   "Guinea",
//   "Gambia",
//   "Guinea-Bissau",
//   "Eq. Guinea",
//   "Greece",
//   "Greenland",
//   "Guatemala",
//   "Guyana",
//   "Honduras",
//   "Croatia",
//   "Haiti",
//   "Hungary",
//   "Indonesia",
//   "India",
//   "Ireland",
//   "Iran",
//   "Iraq",
//   "Iceland",
//   "Israel",
//   "Italy",
//   "Jamaica",
//   "Jordan",
//   "Japan",
//   "Kazakhstan",
//   "Kenya",
//   "Kyrgyzstan",
//   "Cambodia",
//   "South Korea",
//   "Kosovo",
//   "Kuwait",
//   "Laos",
//   "Lebanon",
//   "Liberia",
//   "Libya",
//   "Sri Lanka",
//   "Lesotho",
//   "Lithuania",
//   "Luxembourg",
//   "Latvia",
//   "Morocco",
//   "Moldova",
//   "Madagascar",
//   "Mexico",
//   "Macedonia",
//   "Mali",
//   "Myanmar",
//   "Montenegro",
//   "Mongolia",
//   "Mozambique",
//   "Mauritania",
//   "Malawi",
//   "Malaysia",
//   "Namibia",
//   "New Caledonia",
//   "Niger",
//   "Nigeria",
//   "Nicaragua",
//   "Netherlands",
//   "Norway",
//   "Nepal",
//   "New Zealand",
//   "Oman",
//   "Pakistan",
//   "Panama",
//   "Peru",
//   "Philippines",
//   "Papua New Guinea",
//   "Poland",
//   "Puerto Rico",
//   "North Korea",
//   "Portugal",
//   "Paraguay",
//   "Palestine",
//   "Qatar",
//   "Romania",
//   "Russia",
//   "Rwanda",
//   "W. Sahara",
//   "Saudi Arabia",
//   "Sudan",
//   "S. Sudan",
//   "Senegal",
//   "Solomon Is.",
//   "Sierra Leone",
//   "El Salvador",
//   "Somaliland",
//   "Somalia",
//   "Serbia",
//   "Singapore",
//   "Suriname",
//   "Slovakia",
//   "Slovenia",
//   "Sweden",
//   "Swaziland",
//   "Syria",
//   "Chad",
//   "Togo",
//   "Thailand",
//   "Tajikistan",
//   "Turkmenistan",
//   "Timor-Leste",
//   "Trinidad and Tobago",
//   "Tunisia",
//   "Turkey",
//   "Taiwan",
//   "Tanzania",
//   "Uganda",
//   "Ukraine",
//   "Uruguay",
//   "United States of America",
//   "Uzbekistan",
//   "Venezuela",
//   "Vietnam",
//   "Vanuatu",
//   "Yemen",
//   "South Africa",
//   "Zambia",
//   "Zimbabwe",
// ]

export const PIN_COLORS = _.uniq([
  "#63b598",
  "#ce7d78",
  "#ea9e70",
  "#a48a9e",
  "#c6e1e8",
  "#648177",
  "#0d5ac1",
  "#f205e6",
  "#1c0365",
  "#14a9ad",
  "#4ca2f9",
  "#a4e43f",
  "#d298e2",
  "#6119d0",
  "#d2737d",
  "#c0a43c",
  "#f2510e",
  "#79806e",
  "#cd2f00",
  "#9348af",
  "#01ac53",
  "#c5a4fb",
  "#996635",
  "#b11573",
  "#75d89e",
  "#2f3f94",
  "#2f7b99",
  "#da967d",
  "#34891f",
  "#b0d87b",
  "#ca4751",
  "#7e50a8",
  "#c4d647",
  "#e0eeb8",
  "#11dec1",
  "#566ca0",
  "#ffdbe1",
  "#935b6d",
  "#916988",
  "#aead3a",
  "#9e6d71",
  "#4b5bdc",
  "#0cd36d",
  "#250662",
  "#cb5bea",
  "#ac3e1b",
  "#df514a",
  "#539397",
  "#880977",
  "#f697c1",
  "#ba96ce",
  "#679c9d",
  "#c6c42c",
  "#5d2c52",
  "#48b41b",
  "#e1cf3b",
  "#5be4f0",
  "#57c4d8",
  "#a4d17a",
  "#be608b",
  "#96b00c",
  "#088baf",
  "#f158bf",
  "#e145ba",
  "#ee91e3",
  "#05d371",
  "#5426e0",
  "#4834d0",
  "#802234",
  "#6749e8",
  "#0971f0",
  "#8fb413",
  "#b2b4f0",
  "#c3c89d",
  "#c9a941",
  "#41d158",
  "#fb21a3",
  "#51aed9",
  "#5bb32d",
  "#21538e",
  "#89d534",
  "#d36647",
  "#7fb411",
  "#0023b8",
  "#3b8c2a",
  "#986b53",
  "#f50422",
  "#983f7a",
  "#ea24a3",
  "#79352c",
  "#521250",
  "#c79ed2",
  "#d6dd92",
  "#e33e52",
  "#b2be57",
  "#fa06ec",
  "#1bb699",
  "#6b2e5f",
  "#64820f",
  "#21538e",
  "#89d534",
  "#d36647",
  "#7fb411",
  "#0023b8",
  "#3b8c2a",
  "#986b53",
  "#f50422",
  "#983f7a",
  "#ea24a3",
  "#79352c",
  "#521250",
  "#c79ed2",
  "#d6dd92",
  "#e33e52",
  "#b2be57",
  "#fa06ec",
  "#1bb699",
  "#6b2e5f",
  "#64820f",
  "#9cb64a",
  "#996c48",
  "#9ab9b7",
  "#06e052",
  "#e3a481",
  "#0eb621",
  "#fc458e",
  "#b2db15",
  "#aa226d",
  "#792ed8",
  "#73872a",
  "#520d3a",
  "#cefcb8",
  "#a5b3d9",
  "#7d1d85",
  "#c4fd57",
  "#f1ae16",
  "#8fe22a",
  "#ef6e3c",
  "#243eeb",
  "#dd93fd",
  "#3f8473",
  "#e7dbce",
  "#421f79",
  "#7a3d93",
  "#635f6d",
  "#93f2d7",
  "#9b5c2a",
  "#15b9ee",
  "#0f5997",
  "#409188",
  "#911e20",
  "#1350ce",
  "#10e5b1",
  "#fff4d7",
  "#cb2582",
  "#ce00be",
  "#32d5d6",
  "#608572",
  "#c79bc2",
  "#00f87c",
  "#77772a",
  "#6995ba",
  "#fc6b57",
  "#f07815",
  "#8fd883",
  "#060e27",
  "#96e591",
  "#21d52e",
  "#d00043",
  "#b47162",
  "#1ec227",
  "#4f0f6f",
  "#1d1d58",
  "#947002",
  "#bde052",
  "#e08c56",
  "#28fcfd",
  "#36486a",
  "#d02e29",
  "#1ae6db",
  "#3e464c",
  "#a84a8f",
  "#911e7e",
  "#3f16d9",
  "#0f525f",
  "#ac7c0a",
  "#b4c086",
  "#c9d730",
  "#30cc49",
  "#3d6751",
  "#fb4c03",
  "#640fc1",
  "#62c03e",
  "#d3493a",
  "#88aa0b",
  "#406df9",
  "#615af0",
  "#2a3434",
  "#4a543f",
  "#79bca0",
  "#a8b8d4",
  "#00efd4",
  "#7ad236",
  "#7260d8",
  "#1deaa7",
  "#06f43a",
  "#823c59",
  "#e3d94c",
  "#dc1c06",
  "#f53b2a",
  "#b46238",
  "#2dfff6",
  "#a82b89",
  "#1a8011",
  "#436a9f",
  "#1a806a",
  "#4cf09d",
  "#c188a2",
  "#67eb4b",
  "#b308d3",
  "#fc7e41",
  "#af3101",
  "#71b1f4",
  "#a2f8a5",
  "#e23dd0",
  "#d3486d",
  "#00f7f9",
  "#474893",
  "#3cec35",
  "#1c65cb",
  "#5d1d0c",
  "#2d7d2a",
  "#ff3420",
  "#5cdd87",
  "#a259a4",
  "#e4ac44",
  "#1bede6",
  "#8798a4",
  "#d7790f",
  "#b2c24f",
  "#de73c2",
  "#d70a9c",
  "#88e9b8",
  "#c2b0e2",
  "#86e98f",
  "#ae90e2",
  "#1a806b",
  "#436a9e",
  "#0ec0ff",
  "#f812b3",
  "#b17fc9",
  "#8d6c2f",
  "#d3277a",
  "#2ca1ae",
  "#9685eb",
  "#8a96c6",
  "#dba2e6",
  "#76fc1b",
  "#608fa4",
  "#20f6ba",
  "#07d7f6",
  "#dce77a",
  "#77ecca",
])
